import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { getListService } from '../../redux/actions/serviceBiller';
import { resetFilter } from '../../../../redux/actions/newFilter';

import ServiceList from './ServiceList.page';

const mapStateToProps = state => ({
  listService: state.allbiller.listService,
  serviceFilter: state.allbiller.serviceFilter,
  loading: state.allbiller.loading,
  filterValue: state.newFilter.filterValue,
  formControlShow: state.newFilter.formControlShow,
});

const mapDispatchToProps = {
  getListService,
  resetFilter,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ServiceList));
